<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Introduction">Introduction: Making America Modern</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Jazz and the Spirit of the Times</a></p>
<p class="toc2"><a href="#/Chapter1#C1"><i>Interlude: The Flapper Capital</i></a></p>
<p class="toc"><a href="#/Chapter2#C2">2. A Visit to Jazz Age Chicago</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Beer Flats and Bathtub Gin: Dodging Prohibition</span></p>
<p class="toc2"><span href="#/Chapter3#C3" title="Link target outside of Sample"><i>Interlude: A Chicagoan in Paris</i></span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Perpetrators, Prosecutors and Public Enemies: Organized Crime</span></p>
<p class="toc2"><span href="#/Chapter4#C4" title="Link target outside of Sample"><i>Interlude: Gangster Funerals</i></span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Zigzags, Bungalows and Streamlining: Building a City Moderne</span></p>
<p class="toc2"><span href="#/Chapter5#C5" title="Link target outside of Sample"><i>Interlude: The Women’s World’s Fair</i></span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Jazz Capital of the World</span></p>
<p class="toc2"><span href="#/Chapter6#C6" title="Link target outside of Sample"><i>Interlude: Jazz Me Blues</i></span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. “Guggle and Glub”: The Chicago Art Scene</span></p>
<p class="toc2"><span href="#/Chapter7#C7" title="Link target outside of Sample"><i>Interlude: Harry Keeler’s Naughty Magazine</i></span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Games with a Jazz Beat: Chicago Sports in the Golden Age</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. The Rainbow City and the End of the Jazz Age</span></p>
<p class="toc1"><span href="#/Chicago_Timeline" title="Link target outside of Sample">Chicago Timeline: 1919–1933</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?43193b96